import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { EventModel, EventModelLike } from '../models/event.model';
import {
  OccurrenceModel,
} from '../models/occurrence.model';

interface EventDTOLike {
  id?: string;
  assunto: string;
  descricao: string;
  anexos: {
    id?: string;
    nome: string;
    url: string;
  }[];
  objetos: {
    id?: string;
    tipoObjeto: string;
    idObjetoCadastro: string;
    idEntidade: string;
  }[];
  geometry: string;
}

@Injectable()
export class EventsService {

  constructor(private http: HttpClient) {}

  create(model: EventModelLike) {
    const body = this.modelToApi(model);
    return this.http
      .post<EventDTOLike>(`~Evento`, body)
      .pipe(this.apiToModelOperator());
  }

  private apiToModelOperator() {
    return map((e) => this.apiToModel(e as any));
  }

  private modelToApi(model: EventModelLike): EventDTOLike {
    const modelApi: EventDTOLike = {
      assunto: model.subject,
      descricao: model.description,
      geometry: model.geometry,
      anexos:
        model.attachments?.map((x) => {
          return {
            id: x.id,
            nome: x.text,
            url: x.url,
          };
        }) ?? [],
      objetos:
        model.objects?.map((x) => {
          return {
            id: x.id,
            tipoObjeto: x.type,
            idEntidade: x.entityId,
            idObjetoCadastro: x.objectRegisterId,
          };
        }) ?? [],
    };

    if (model?.id) {
      modelApi.id = model.id;
    }

    return modelApi;
  }

  private apiToModel(apiModel: EventDTOLike): EventModel {
    const model: EventModelLike = {
      id: apiModel.id,
      geometry: apiModel.geometry,
      subject: apiModel.assunto,
      description: apiModel.descricao,
      attachments:
        apiModel.anexos?.map((x) => {
          return {
            id: x.id,
            text: x.nome,
            url: x.url,
          };
        }) ?? [],
      objects:
        apiModel.objetos?.map((x) => {
          return {
            id: x.id,
            type: x.tipoObjeto,
            entityId: x.idEntidade,
            objectRegisterId: x.idObjetoCadastro,
          };
        }) ?? [],
    };

    return new OccurrenceModel(model);
  }
}
